export function getPasswordStrength(password: string): number {
	return [
		password.length >= 8,
		/[a-z]/.test(password),
		/[A-Z]/.test(password),
		/[0-9]/.test(password),
		/[^A-Za-z0-9]/.test(password),
	].filter(Boolean).length;
}

const CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*';

function generate(): string {
	return [...new Array(12)]
		.map(() => CHARS.charAt(Math.floor(Math.random() * CHARS.length)))
		.join('');
}

export function generatePassword(attempt = 1): string {
	const result = generate();

	const strength = getPasswordStrength(result);
	if (strength < 5 && attempt < 10) {
		return generatePassword(attempt + 1);
	}

	return result;
}
